import React from 'react';
import withStyles from '@mui/styles/withStyles';
import CreatePatientForm from 'containers/patient/create-patient/create-patient-form';
import { Switch, Route } from 'react-router-dom';
import { styles } from '../nav-styles';

const CreatePatient = ({ classes }) => (
  <div className={classes.scheduleListContent}>
    <Switch>
      <Route component={CreatePatientForm} />
    </Switch>
  </div>
);

export default withStyles(styles, { withTheme: true })(CreatePatient);
